export enum AlertType {
  Success = 0,
  Warning = 1,
  Error = 2,
  Message = 3
}
